module.exports = __webpack_public_path__ + "media/images/payment_methods/giropay-724c4b563888e8646a372db0ca8f9145.svg";